export interface FAQItem {
  question: string;
  answer: string;
}

export interface ConverterData {
  slug: string;
  title: string;
  metaDescription: string;
  h1: string;
  description: string;
  iconType: 'pdf' | 'excel' | 'word' | 'image' | 'xml' | 'json' | 'csv' | 'smart';
  fromFormat: string;
  toFormat: string;
  faqs: FAQItem[];
  features: string[];
  steps: string[];
}

export const CONVERTERS_DATA: Record<string, ConverterData> = {
  'pdf-para-excel': {
    slug: 'pdf-para-excel',
    title: 'PDF para Excel - Converter Tabelas PDF em Planilhas Gratuitamente',
    metaDescription: 'Converta seus arquivos PDF em planilhas Excel editáveis com precisão cirúrgica. Extraia tabelas automaticamente sem perder a formatação original.',
    h1: 'Conversor de PDF para Excel Inteligente',
    description: 'Nossa tecnologia de IA identifica tabelas em seus documentos PDF e as reconstrói perfeitamente em arquivos .xlsx ou .csv.',
    iconType: 'pdf',
    fromFormat: 'PDF',
    toFormat: 'EXCEL',
    features: [
      'Extração automática de tabelas',
      'Preservação de formatação de células',
      'Suporte a arquivos protegidos por senha',
      'Processamento em lote (Plano Pro)'
    ],
    steps: [
      'Arraste e solte seu arquivo PDF na área de upload.',
      'Aguarde alguns segundos enquanto nossa IA analisa as tabelas.',
      'Clique em "Baixar Excel" para obter seu arquivo editável.'
    ],
    faqs: [
      { question: 'A conversão é segura?', answer: 'Sim, todos os arquivos são processados em servidores criptografados e excluídos permanentemente após 1 hora.' },
      { question: 'O FiscalOnne extrai tabelas de PDFs escaneados?', answer: 'Sim, utilize nossa ferramenta de OCR Inteligente para converter documentos que foram impressos e escaneados.' }
    ]
  },
  // Removido: 'pdf-para-word' (sem implementação real — gerava DOCX inválido).

  'xml-para-pdf': {
    slug: 'xml-para-pdf',
    title: 'XML para PDF - Gerador de DANFE e Relatórios de Notas Fiscais',
    metaDescription: 'Converta arquivos XML de Notas Fiscais (NF-e, NFS-e, CT-e) em PDF profissional com visualização clara e organizada.',
    h1: 'Conversor XML para PDF Profissional',
    description: 'A especialidade do FiscalOnne: transforme dados brutos de XML em documentos legíveis e elegantes.',
    iconType: 'xml',
    fromFormat: 'XML',
    toFormat: 'PDF',
    features: [
      'Layouts customizáveis',
      'Cálculo automático de impostos',
      'Logotipo da empresa no cabeçalho'
    ],
    steps: [
      'Suba um ou mais arquivos XML.',
      'Escolha um de nossos modelos premium.',
      'Gere e baixe seu PDF em segundos.'
    ],
    faqs: [
      { question: 'O FiscalOnne suporta todas as cidades?', answer: 'Suportamos mais de 2.000 prefeituras para conversão de NFS-e.' }
    ]
  },
  'comprimir-pdf': {
    slug: 'comprimir-pdf',
    title: 'Comprimir PDF - Reduzir Tamanho de PDF Online sem Perder Qualidade',
    metaDescription: 'Reduza o tamanho do seu PDF para enviar por e-mail ou subir em portais do governo. Otimização inteligente de imagens e fontes.',
    h1: 'Comprimir PDF com Otimização Inteligente',
    description: 'Diminua o peso dos seus documentos sem sacrificar a legibilidade ou a qualidade das imagens.',
    iconType: 'pdf',
    fromFormat: 'PDF',
    toFormat: 'PDF (Otimizado)',
    features: [
      'Redução de até 90% no tamanho',
      'Otimização de imagens internas',
      'Compatibilidade total com visualizadores PDF'
    ],
    steps: [
      'Faça o upload do seu PDF pesado.',
      'Escolha o nível de compressão desejado.',
      'Baixe o arquivo otimizado.'
    ],
    faqs: [
      { question: 'A qualidade da imagem diminui muito?', answer: 'Nossa tecnologia foca em remover metadados e otimizar vetores antes de comprimir imagens, mantendo a qualidade excelente.' }
    ]
  },
  // Removido: 'pdf-para-xml' (sem extração estruturada real — gerava XML inválido).

  'mesclar-pdf': {
    slug: 'mesclar-pdf',
    title: 'Mesclar PDF - Combinar Vários Arquivos PDF em Um Só Online',
    metaDescription: 'Junte vários documentos PDF em um único arquivo de forma rápida e segura. Organize suas páginas como desejar.',
    h1: 'Mesclar e Combinar Documentos PDF',
    description: 'A maneira mais simples de unir seus relatórios, faturas ou documentos em um único arquivo PDF organizado.',
    iconType: 'pdf',
    fromFormat: 'Múltiplos PDFs',
    toFormat: 'PDF Único',
    features: [
      'Ordenação por arraste e solte',
      'Sem limite de arquivos no plano Pro',
      'Fusão instantânea de alta velocidade'
    ],
    steps: [
      'Suba todos os PDFs que deseja unir.',
      'Reorganize a ordem dos arquivos se necessário.',
      'Clique em "Mesclar" e baixe o resultado.'
    ],
    faqs: [
      { question: 'Existe limite de arquivos?', answer: 'No plano gratuito você pode mesclar até 5 arquivos por vez.' }
    ]
  },
  // Removido: 'ocr-inteligente' (sem OCR funcional — ocultado até implementação real).

  // Removido: 'excel-para-pdf' (renderização real ainda não implementada).

  'excel-para-csv': {
    slug: 'excel-para-csv',
    title: 'Excel para CSV - Converter Planilhas em Formato CSV Leve',
    metaDescription: 'Converta arquivos Excel para CSV para integração com bancos de dados e sistemas de análise de dados de forma simples.',
    h1: 'Conversor de Excel para CSV de Alta Velocidade',
    description: 'Exporte seus dados para o formato universal CSV sem erros de codificação ou perda de caracteres.',
    iconType: 'excel',
    fromFormat: 'EXCEL',
    toFormat: 'CSV',
    features: [
      'Escolha de delimitador (vírgula ou ponto e vírgula)',
      'Suporte a UTF-8 para caracteres especiais',
      'Extração rápida de grandes volumes de dados'
    ],
    steps: [
      'Suba sua planilha de dados.',
      'Selecione as opções de exportação.',
      'Baixe o arquivo CSV resultante.'
    ],
    faqs: []
  },
  // Removido completamente: 'remover-fundo-imagem' (dependeria de IA paga recorrente).

  'json-para-excel': {
    slug: 'json-para-excel',
    title: 'JSON para Excel - Converter Dados JSON em Planilhas',
    metaDescription: 'Converta arquivos JSON complexos em planilhas Excel organizadas de forma simples e intuitiva.',
    h1: 'Conversor JSON para Excel Inteligente',
    description: 'Transforme estruturas de dados complexas em tabelas legíveis no Excel.',
    iconType: 'json',
    fromFormat: 'JSON',
    toFormat: 'EXCEL',
    features: [
      'Planificação de objetos aninhados',
      'Mapeamento automático de cabeçalhos',
      'Processamento de grandes conjuntos de dados'
    ],
    steps: [
      'Suba seu arquivo .json ou cole o código.',
      'Aguarde la estruturação das colunas.',
      'Baixe o arquivo .xlsx pronto.'
    ],
    faqs: []
  },
  'xml-para-excel': {
    slug: 'xml-para-excel',
    title: 'XML para Excel - Converter XML de Notas em Planilha',
    metaDescription: 'Converta arquivos XML de NF-e, NFC-e e CT-e em planilhas Excel para controle fiscal e auditoria.',
    h1: 'Transformar XML em Planilha de Dados',
    description: 'Ideal para contadores: extraia todos os dados de múltiplos XMLs diretamente para o Excel.',
    iconType: 'xml',
    fromFormat: 'XML',
    toFormat: 'EXCEL',
    features: [
      'Conversão em lote de centenas de arquivos',
      'Extração de itens de nota detalhados',
      'Padronização de colunas para auditoria'
    ],
    steps: [
      'Selecione os arquivos XML.',
      'O sistema unificará os dados em uma tabela.',
      'Baixe sua planilha completa.'
    ],
    faqs: []
  },
  'png-para-jpg': {
    slug: 'png-para-jpg',
    title: 'PNG para JPG - Converter Imagens PNG em JPG Online',
    metaDescription: 'Converta imagens PNG para JPG de forma rápida, mantendo a qualidade e reduzindo o tamanho do arquivo.',
    h1: 'Conversor de PNG para JPG Rápido',
    description: 'Mude o formato de suas imagens em massa com apenas um clique.',
    iconType: 'image',
    fromFormat: 'PNG',
    toFormat: 'JPG',
    features: [
      'Conversão ultrarrápida',
      'Redução de tamanho de arquivo',
      'Sem perda visível de qualidade'
    ],
    steps: [
      'Suba seus arquivos PNG.',
      'O sistema fará a conversão instantânea.',
      'Baixe as novas imagens em JPG.'
    ],
    faqs: []
  },
  'remover-senha-pdf': {
    slug: 'remover-senha-pdf',
    title: 'Remover Senha de PDF - Desbloquear PDF Protegido Online',
    metaDescription: 'Remova a senha de PDFs que você tem autorização para desbloquear. Informe a senha correta e baixe uma cópia sem proteção, com segurança e privacidade.',
    h1: 'Remover Senha de PDF Protegido',
    description: 'Envie um PDF protegido, informe a senha que você já conhece e receba uma cópia desbloqueada. Não tentamos quebrar nem adivinhar senhas.',
    iconType: 'pdf',
    fromFormat: 'PDF',
    toFormat: 'PDF',
    features: [
      'Detecção automática de PDFs protegidos',
      'Processamento 100% no seu navegador',
      'Senha nunca é salva ou enviada para servidores',
      'Arquivo temporário descartado após o download'
    ],
    steps: [
      'Envie um arquivo .pdf que você tenha autorização para desbloquear.',
      'Se houver senha, informe-a no campo seguro exibido.',
      'Baixe a cópia gerada sem senha.'
    ],
    faqs: [
      { question: 'Vocês conseguem descobrir a senha do meu PDF?', answer: 'Não. A ferramenta nunca tenta quebrar, adivinhar ou burlar senhas. A remoção só ocorre se você informar a senha correta.' },
      { question: 'Minha senha fica armazenada?', answer: 'Não. A senha é usada apenas em memória no seu navegador, descartada após a geração do PDF e nunca aparece em logs ou banco de dados.' },
      { question: 'É legal usar esta ferramenta?', answer: 'Use apenas em arquivos seus ou em documentos para os quais você tenha autorização explícita do proprietário.' }
    ]
  }
};

